// Import CSS first with correct path
import './style.css';
import { fetchOrderDetails } from './utils/api.js';
import { formatPrice } from './utils/formatting.js';

// Add global error handler
window.addEventListener('error', (event) => {
    console.error('[Global Error]', event.error);
    document.getElementById('app').innerHTML = `
        <div class="min-h-screen flex items-center justify-center">
            <div class="bg-white p-8 rounded-lg shadow-md text-center">
                <h1 class="text-2xl font-bold text-red-600">Fatal Error</h1>
                <p class="mt-2 text-sm text-gray-500">${event.error.message}</p>
            </div>
        </div>
    `;
});

async function renderOrderConfirmation() {
    const appElement = document.querySelector('#app');
    console.log('[INIT] Starting renderOrderConfirmation');
    
    try {
        // Check URL path immediately
        const pathParts = window.location.pathname.split('/').filter(Boolean);
        
        // Show "No order found" message if no order ID is present
        if (pathParts.length === 0) {
            appElement.innerHTML = `
                <div class="min-h-screen flex items-center justify-center">
                    <div class="bg-white p-8 rounded-lg shadow-md text-center">
                        <h1 class="text-2xl font-bold text-gray-900">Ingen ordre funnet</h1>
                        <p class="mt-4">Vennligst bruk en gyldig ordrebekreftelse-URL.</p>
                    </div>
                </div>
            `;
            return;
        }

        // Show loading state while fetching
        appElement.innerHTML = `
            <div class="min-h-screen flex items-center justify-center">
                <div class="text-center">
                    <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
                    <p class="mt-4 text-gray-600">Henter ordredetaljer...</p>
                </div>
            </div>
        `;

        console.log('[DEBUG] Fetching order details...');
        const orderData = await fetchOrderDetails();
        console.log('[DEBUG] Order data received:', orderData);

        if (!orderData) {
            appElement.innerHTML = `
                <div class="min-h-screen flex items-center justify-center">
                    <div class="bg-white p-8 rounded-lg shadow-md text-center">
                        <h1 class="text-2xl font-bold text-gray-900">Ingen ordre funnet</h1>
                        <p class="mt-4">Vennligst bruk en gyldig ordrebekreftelse-URL.</p>
                    </div>
                </div>
            `;
            return;
        }

        appElement.innerHTML = `
            <div class="min-h-screen py-12 px-4 sm:px-6 lg:px-8">
                <div class="max-w-3xl mx-auto">
                    <div class="text-center mb-8">
                        <img src="https://farskapet.no/cdn/shop/files/Farskaept.logo.png?v=1733004530&width=400" 
                             alt="Farskapet Logo" 
                             class="h-16 mx-auto mb-6">
                        <h1 class="text-3xl font-bold text-gray-900">Takk for din bestilling!</h1>
                        <p class="mt-2 text-lg text-gray-600">Ordrenummer: #${orderData.orderNumber}</p>
                    </div>

                    <div class="bg-white shadow rounded-lg mb-8">
                        <div class="p-6">
                            <h2 class="text-xl font-semibold mb-4">Leveringsinformasjon</h2>
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <h3 class="font-medium text-gray-700">Leveringsadresse</h3>
                                    <p class="mt-1">${orderData.customer.shippingAddress.name}</p>
                                    <p>${orderData.customer.shippingAddress.address1}</p>
                                    <p>${orderData.customer.shippingAddress.zip} ${orderData.customer.shippingAddress.city}</p>
                                </div>
                                <div>
                                    <h3 class="font-medium text-gray-700">Kontaktinformasjon</h3>
                                    <p class="mt-1">E-post: ${orderData.customer.email}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="bg-white shadow rounded-lg mb-8">
                        <div class="p-6">
                            <h2 class="text-xl font-semibold mb-4">Ordredetaljer</h2>
                            <div class="space-y-4">
                                ${orderData.items.map(item => `
                                    <div class="flex justify-between items-center py-2 border-b border-gray-200">
                                        <div>
                                            <p class="font-medium">${item.title}</p>
                                            <p class="text-sm text-gray-600">Antall: ${item.quantity}</p>
                                        </div>
                                        <p class="font-medium">${formatPrice(item.price * item.quantity)}</p>
                                    </div>
                                `).join('')}
                                
                                <div class="pt-4">
                                    <div class="flex justify-between items-center">
                                        <p class="text-gray-600">Frakt</p>
                                        <p>${formatPrice(orderData.shippingPrice)}</p>
                                    </div>
                                    <div class="flex justify-between items-center font-bold text-lg mt-2">
                                        <p>Totalt</p>
                                        <p>${formatPrice(orderData.totalPrice)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="text-center">
                        <a href="https://farskapet.no" 
                           class="inline-block bg-gradient-to-r from-blue-500 to-blue-600 text-white font-medium px-8 py-3 rounded-full hover:opacity-90 transition-opacity">
                            Tilbake til butikken
                        </a>
                    </div>
                </div>
            </div>
        `;
    } catch (error) {
        console.error('[ERROR] Render failed:', error);
        appElement.innerHTML = `
            <div class="min-h-screen flex items-center justify-center">
                <div class="bg-white p-8 rounded-lg shadow-md text-center">
                    <h1 class="text-2xl font-bold text-red-600">Feil ved lasting av ordre</h1>
                    <p class="mt-4">Vennligst kontakt kundeservice på post@farskapet.no</p>
                    <p class="mt-2 text-sm text-gray-500">Feilmelding: ${error.message}</p>
                </div>
            </div>
        `;
    }
}

// Initialize immediately
renderOrderConfirmation().catch(error => {
    console.error('[INIT] Fatal error:', error);
});

// Log that the script has loaded
console.log('[INIT] Script loaded');